/**
 * 🏮 Sovereign Cabinet Registry (Events)
 * 實施規範：SOVEREIGN_ARCH_GUIDELINE.md
 * 職責：定義全域事件常數，防止因拼寫錯誤導致的「聯動失效」。
 */

export const SovereignEvents = {
    // 核心事件
    MAP_READY: 'MAP_READY',
    MAP_CLICK: 'map:click',
    
    // 認證事件
    AUTH_STATE_CHANGED: 'SOVEREIGN_AUTH',
    
    // 分時圈相關 (Isochrone) 對位
    ISOC_RENDERED: 'isochrone:rendered',
    ISOC_CLEARED: 'isochrone:cleared',
    ISOC_600_THRESHOLD: 'isochrone:threshold:600s', // 10 分鐘感知
    
    // 興趣點相關 (POI)
    POI_LOADED: 'poi:loaded',
    POI_SEARCH_REQUEST: 'poi:search:request',
    
    // 交通與停車 (Transit & Parking)
    PARKING_LOADED: 'parking:loaded',
    PARKING_AUTO_EXPAND: 'parking:auto_expand',  // 聯動觸發
    BUS_ROUTE_TOGGLED: 'bus:route:toggled',
    RAIL_STATION_SELECTED: 'rail:station:selected',
    
    // 系統與輸出
    EXPORT_READY: 'export:ready',
    SCREENSHOT_START: 'screenshot:start_clean',
    SCREENSHOT_MODE_CHANGE: 'screenshot:mode_change', // 模式 A/B 切換
    SCREENSHOT_END: 'screenshot:end',
    NOTIFICATION: 'system:notification'
};

// 全域掛載以支持非 ES 模組調用（備援）
if (typeof window !== 'undefined') {
    window.SovereignEvents = SovereignEvents;
}
